const convertToCSV = (objArray) => {
  const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray
  let str = ''

  for (let i = 0; i < array.length; i++) {
    let line = ''
    for (const index in array[i]) {
      if (line !== '') line += ','

      line += array[i][index]
    }

    str += line + '\r\n'
  }

  return str
}

const exportCSVFile = (headers, items, fileTitle) => {
  if (headers) {
    items.unshift(headers)
  }

  // Convert Object to JSON
  const jsonObject = JSON.stringify(items)

  const csv = convertToCSV(jsonObject)

  const exportedFilename = fileTitle + '.csv' || 'export.csv'

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, exportedFilename)
  } else {
    const link = document.createElement('a')
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      const url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', exportedFilename)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}

export const downloadCSV = (data) => {
  const headers = {
    noteId: 'Note ID'.replace(/,/g, ''), // remove commas to avoid errors
    content: 'Content',
    timestamp: 'Timestamp',
    userId: 'User',
  }

  const itemsFormatted = []

  // format the data
  data.forEach((item) => {
    itemsFormatted.push({
      noteId: item.noteId.replace(/,/g, ''), // remove commas to avoid errors,
      content: item.content,
      timestamp: item.timestamp,
      userId: item.userId,
    })
  })

  const today = new Date()
  const yyyy = today.getFullYear()
  const mm = today.getMonth() + 1 // Months start at 0!
  const dd = today.getDate()

  const fileTitle = `mantle_notes_${mm}_${dd}_${yyyy}`

  exportCSVFile(headers, itemsFormatted, fileTitle) // call the exportCSVFile() function to process the JSON and trigger the download
}
